<template lang="pug">
  .changes-header
    .changes-header__wrap
      .changes-header__title-container
        .changes-header__title-group(v-if="showGroupTitle")
          p {{ groupTitle }}
        .changes-header__title-items
          .changes-header__title-item
            p.changes-header__sub-item(v-if="extraField") TYPE
            p Field
          .changes-header__title-item
            p Old Value
          .changes-header__title-item
            p New Value
    .changes-header__content(ref='content')
      slot
</template>

<script>
export default {
  name: 'ChangesHeader',
  props: {
    groupTitle: {
      type: String,
      default: 'Changed Fields',
    },
    showGroupTitle: {
      type: Boolean,
      default: true,
    },
    extraField: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .changes-header
    margin-left 10px
    width: calc(100% - 10px)

    &__wrap
      margin-left 20%
      min-height 48px
      width calc(100% - 20%)

    &__title-container
      width: 100%

    &__title-group
      background-color: $default-color-light-1
      width 100%
      color: $default-color-bold
      font-weight: 600;
      padding: 15px 20px
      margin-bottom: 2px

    &__sub-item
      margin-bottom 10px

    &__title-items
      width 100%
      display flex
    &__title-item
      display flex
      justify-content flex-end
      flex-direction column
      padding: 15px 20px
      color: $default-color
      font-weight: 600
      font-size: 90%
      width 35%
      background-color: $default-color-light-2
      margin-bottom 10px
      &:first-child
        width 30%
        margin-right 10px
      &:last-child
        margin-left 2px



  @media (max-width: $tablet)
    .changes-header
      &__wrap
        display: none
</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/ChangesHeader.vue